


















































































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';

export default defineComponent({
  name: 'BasePaginationEjected',
  components: {
    BaseIcon,
    BaseLink,
    BaseButton,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Number,
      default: 5,
    },
    hasArrows: {
      type: Boolean,
      default: true,
    },
    current: {
      type: Number,
      default: 1,
    },
    pageParamName: {
      type: String,
      default: 'page',
    },
  },
  computed: {
    hasRouter(): any {
      // @ts-ignore migrated from ui-library
      return this.$route;
    },
    currentPage(): any {
      // @ts-ignore migrated from ui-library
      return this.hasRouter
        ? // @ts-ignore migrated from ui-library
          this.$route.query[this.pageParamName]
          ? // @ts-ignore migrated from ui-library
            parseInt(this.$route.query[this.pageParamName], 10)
          : 1
        : this.current;
    },
    getPrev(): any {
      return this.currentPage === this.firstVisiblePageNumber
        ? this.currentPage
        : this.currentPage - 1;
    },
    canGoPrev(): any {
      return this.currentPage !== this.firstVisiblePageNumber;
    },
    getNext(): any {
      return this.currentPage === this.lastVisiblePageNumber
        ? this.currentPage
        : this.currentPage + 1;
    },
    canGoNext(): any {
      return this.currentPage !== this.lastVisiblePageNumber;
    },
    showFirst(): any {
      return this.firstVisiblePageNumber > 1;
    },
    showLast(): any {
      return this.lastVisiblePageNumber < this.total;
    },
    listOfPageNumbers(): any {
      return Array.from(Array(this.total), (_, i) => i + 1);
    },
    limitedPageNumbers(): any {
      if (this.total <= this.visible) {
        return this.listOfPageNumbers;
      }
      if (this.currentPage < this.visible - Math.floor(this.visible / 2) + 1) {
        return this.listOfPageNumbers.slice(0, this.visible);
      }
      if (this.total - this.currentPage < this.visible - Math.ceil(this.visible / 2) + 1) {
        return this.listOfPageNumbers.slice(this.total - this.visible);
      }
      return this.listOfPageNumbers.slice(
        this.currentPage - Math.ceil(this.visible / 2),
        this.currentPage + Math.floor(this.visible / 2),
      );
    },
    firstVisiblePageNumber(): any {
      return this.limitedPageNumbers[0];
    },
    lastVisiblePageNumber(): any {
      return this.limitedPageNumbers[this.limitedPageNumbers.length - 1];
    },
  },
  methods: {
    // @ts-ignore migrated from ui-library
    go(page) {
      this.$emit('click', page);
    },
    // @ts-ignore migrated from ui-library
    getLinkTo(page) {
      const pageNumber = page.toString();
      if (this.hasRouter) {
        return {
          // @ts-ignore migrated from ui-library
          ...this.$route,
          // @ts-ignore migrated from ui-library
          query: { ...this.$route.query, [this.pageParamName]: page },
        };
      } else {
        return pageNumber;
      }
    },
  },
});
